import { Copy } from 'lucide-react'
import { useId, useState } from 'react'

import { Button } from './Button'

/** Копируется только переданный экраном текст; отказ clipboard оставляет доступное поле ручного копирования. */
export function DiagnosticCopy({ text, label = 'Скопировать ошибку' }: { text: string; label?: string }) {
  const reportId = useId()
  const [copied, setCopied] = useState<string | null>(null)
  const [fallback, setFallback] = useState<string | null>(null)
  const copy = async () => {
    try {
      if (globalThis.navigator?.clipboard?.writeText === undefined) throw new Error('Clipboard unavailable')
      await navigator.clipboard.writeText(text)
      setCopied(text)
      setFallback(null)
    } catch {
      setCopied(null)
      setFallback(text)
    }
  }
  return <div className="krp-diagnostic-copy">
    <Button variant="ghost" icon={<Copy size={14} aria-hidden="true" />} onClick={() => { void copy() }}>{label}</Button>
    {copied === text && <span role="status">Скопировано</span>}
    {fallback === text && <div>
      <label htmlFor={reportId}>Текст для передачи администратору</label>
      <textarea id={reportId} readOnly rows={6} value={text} onFocus={(event) => event.currentTarget.select()} />
      <p>Выделите текст и скопируйте вручную или сделайте снимок экрана.</p>
    </div>}
  </div>
}
